import { gql } from '@apollo/client';

export const PACK_INVENTORY_UNIT = gql`
  mutation PackInventoryUnit($data: PackInventoryUnitInput!) {
    packInventoryUnit(data: $data) {
      message
      data {
        unitId
        unitCode
        qrCode
        orderId
        orderItemId
        result
        unitStatus
        orderItemStatus
        isOrderItemFulfilled
        isOrderItemMapped
        failedPieces
        failedChecklistItems
        totalPiecesPresent
        missingContentIds
        message
      }
    }
  }
`;

export const CONFIRM_RETURN_ORDER_V2 = gql`
  mutation ConfirmReturnOrderV2(
    $where: ReturnOrderUniqueInput!
    $data: ConfirmReturnOrderV2Input
  ) {
    confirmReturnOrderV2(where: $where, data: $data) {
      message
      data {
        inventoryUnits {
          unitId
          unitCode
          qrCode
          returnOrderItemId
          eventType
          result
          status
          isAlreadyProcessed
          totalPiecesPresent
          missingContentIds
          failedPieces
          failedChecklistItems
          damageRequestId
        }
      }
    }
  }
`;

export const MARK_INVENTORY_UNIT_DAMAGED = gql`
  mutation MarkInventoryUnitDamaged($data: MarkInventoryUnitDamagedInput!) {
    markInventoryUnitDamaged(data: $data) {
      message
      data {
        unitId
        unitCode
        qrCode
        previousStatus
        status
        videoKey
        damageRequestId
        releasedOrderItemId
        failedPieces
        failedChecklistItems
      }
    }
  }
`;
